import React from "react";

export default function PrivacyPolicy() {
    return (
        <div className="min-h-screen bg-white px-6 md:px-20 py-20">
            <h1 className="font-display text-4xl mb-8">Privacy Policy</h1>

            <div className="max-w-3xl text-sm text-gray-600 space-y-6 font-sans">

                <p>
                    At AURÉNE, we respect your privacy and are committed to protecting
                    your personal data.
                </p>

                <p>
                    Any information you provide is used solely to process orders and
                    improve your shopping experience.
                </p>

                <p>
                    We do not sell or share your personal information with third parties
                    without your consent.
                </p>

                <p>
                    By using our website, you agree to our privacy practices described
                    here.
                </p>

            </div>
        </div>
    );
}